var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHappy24HourMeal = function SvgHappy24HourMeal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FDF6E9",
    d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EAA839",
    fillRule: "evenodd",
    d: "M10 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12m2.959-3.857a.5.5 0 0 0 .493-.493V7.513a.494.494 0 0 0-.888-.315l-2.48 3.222a.494.494 0 0 0 .396.789h1.972v.44a.494.494 0 0 0 .507.494m-1.48-1.92.986-1.263v1.263zM8.395 7.086a1.85 1.85 0 0 0-1.848 1.848.493.493 0 0 0 .986 0 .86.86 0 0 1 .862-.862.658.658 0 0 1 .473 1.098l-2.15 2.131a.493.493 0 0 0 .362.842h2.44a.493.493 0 0 0 0-.987H8.27l1.315-1.315a1.618 1.618 0 0 0-1.19-2.755",
    clipRule: "evenodd"
  })));
};
export default SvgHappy24HourMeal;